(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-card-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function ocultarTarjetasSinFoto() {
      document.querySelectorAll('[data-fp-sin-foto]').forEach(function (marca) {
        if (marca.dataset.fpProcesada === 'true') return;
        marca.dataset.fpProcesada = 'true';
        var tarjeta = marca.closest('product-card') || marca.closest('.product-card');
        if (!tarjeta) return;
        tarjeta.classList.add('fp-card-oculta');
        var contenedor = tarjeta.parentElement;
        if (contenedor && /^(LI)$/.test(contenedor.tagName)) {
          contenedor.classList.add('fp-card-oculta-padre');
        }
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', ocultarTarjetasSinFoto);
    } else {
      ocultarTarjetasSinFoto();
    }
    var observador = new MutationObserver(function () { ocultarTarjetasSinFoto(); });
    observador.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('shopify:section:load', ocultarTarjetasSinFoto);

    if (window.__fpCardOverlaysInit) return;
    window.__fpCardOverlaysInit = true;

    function formatEUR(cents) {
      if (cents == null) return '';
      var n = Number(cents) / 100;
      try { return n.toLocaleString('es-ES', { style: 'currency', currency: 'EUR', minimumFractionDigits: 2 }); }
      catch (e) { return n.toFixed(2).replace('.', ',') + ' €'; }
    }

    function inicializarEstrellas() {
      if (!window.FPWishlist) return;
      document.querySelectorAll('[data-fp-wish]').forEach(function (btn) {
        var handle = btn.getAttribute('data-fp-handle');
        if (!handle) return;
        if (window.FPWishlist.isSaved(handle)) { btn.classList.add('is-active'); btn.setAttribute('aria-pressed', 'true'); }
        else { btn.classList.remove('is-active'); btn.setAttribute('aria-pressed', 'false'); }
      });
    }

    document.addEventListener('click', function (ev) {
      var wish = ev.target.closest('[data-fp-wish]');
      if (wish) {
        ev.preventDefault(); ev.stopPropagation();
        var handle = wish.getAttribute('data-fp-handle');
        if (!handle || !window.FPWishlist) return;
        var activo = window.FPWishlist.toggle(handle);
        wish.classList.toggle('is-active', activo);
        wish.setAttribute('aria-pressed', activo ? 'true' : 'false');
        return;
      }
      var qa = ev.target.closest('[data-fp-quick-add]');
      if (qa) {
        ev.preventDefault(); ev.stopPropagation();
        var wrap = qa.closest('[data-fp-card-overlays]');
        var dataEl = wrap ? wrap.querySelector('script[data-fp-qa-data]') : null;
        if (!dataEl) return;
        try { var data = JSON.parse(dataEl.textContent); abrirModal(data); }
        catch (e) { console.error('[fp] quick-add data parse', e); }
      }
    }, true);

    document.addEventListener('fp:wishlist-cambiada', inicializarEstrellas);
    inicializarEstrellas();
    var mo = new MutationObserver(inicializarEstrellas);
    mo.observe(document.documentElement, { childList: true, subtree: true });

    var modalEl = null;
    var estadoModal = { data: null, variante: null };

    function crearModal() {
      if (modalEl) return modalEl;
      modalEl = document.createElement('div');
      modalEl.className = 'fp-qa-modal';
      modalEl.setAttribute('role', 'dialog');
      modalEl.setAttribute('aria-modal', 'true');
      modalEl.innerHTML =
        '<div class="fp-qa-modal__overlay" data-fp-qa-cerrar></div>' +
        '<div class="fp-qa-modal__panel">' +
          '<button type="button" class="fp-qa-modal__close" data-fp-qa-cerrar aria-label="Cerrar">&#10005;</button>' +
          '<div class="fp-qa-modal__media"><img data-fp-qa-img alt=""></div>' +
          '<div class="fp-qa-modal__body">' +
            '<p class="fp-qa-modal__editorial" data-fp-qa-editorial></p>' +
            '<h2 class="fp-qa-modal__title" data-fp-qa-title></h2>' +
            '<div class="fp-qa-modal__prices" data-fp-qa-prices></div>' +
            '<p class="fp-qa-modal__sizes-label" data-fp-qa-sizes-label>Talla</p>' +
            '<div class="fp-qa-modal__sizes" data-fp-qa-sizes></div>' +
            '<p class="fp-qa-modal__error" data-fp-qa-error></p>' +
            '<button type="button" class="fp-qa-modal__cta" data-fp-qa-add>AÑADIR A LA CESTA</button>' +
            '<a class="fp-qa-modal__details" data-fp-qa-details href="#">Ver detalles</a>' +
          '</div>' +
        '</div>';
      document.body.appendChild(modalEl);
      modalEl.addEventListener('click', function (ev) {
        if (ev.target.closest('[data-fp-qa-cerrar]')) cerrarModal();
        var sz = ev.target.closest('[data-fp-qa-size]');
        if (sz && !sz.classList.contains('is-oos')) { var vid = sz.getAttribute('data-fp-qa-size'); seleccionarVariante(vid); }
        if (ev.target.closest('[data-fp-qa-add]')) intentarAgregar();
      });
      document.addEventListener('keydown', function (ev) {
        if (ev.key === 'Escape' && modalEl.classList.contains('is-open')) cerrarModal();
      });
      return modalEl;
    }

    function encontrarEjeTalla(options) {
      if (!options || !options.length) return -1;
      for (var i = 0; i < options.length; i++) {
        var n = (options[i] && (options[i].name || options[i])) || '';
        if (/talla|size/i.test(String(n))) return i;
      }
      if (options.length === 1) {
        var only = (options[0].name || options[0]) || '';
        if (!/color/i.test(String(only))) return 0;
      }
      return -1;
    }

    function pintarPrecios(v, data) {
      var cont = modalEl.querySelector('[data-fp-qa-prices]');
      var price = v ? v.price : data.price;
      var compare = v ? v.compare_at_price : data.compare_at_price;
      var conDescuento = compare && Number(compare) > Number(price);
      var html = '';
      if (conDescuento) {
        var pct = Math.round((1 - Number(price) / Number(compare)) * 100);
        html += '<span class="fp-qa-modal__price">' + formatEUR(price) + '</span>';
        html += '<span class="fp-qa-modal__compare">' + formatEUR(compare) + '</span>';
        html += '<span class="fp-qa-modal__disc">-' + pct + '%</span>';
      } else {
        html += '<span class="fp-qa-modal__price fp-qa-modal__price--no-sale">' + formatEUR(price) + '</span>';
      }
      cont.innerHTML = html;
    }

    function pintarTallas(data) {
      var cont = modalEl.querySelector('[data-fp-qa-sizes]');
      var label = modalEl.querySelector('[data-fp-qa-sizes-label]');
      cont.innerHTML = '';
      var eje = encontrarEjeTalla(data.options);
      var variantes = data.variants || [];
      if (variantes.length <= 1) { label.style.display = 'none'; cont.style.display = 'none'; estadoModal.variante = variantes[0] || null; return; }
      label.style.display = ''; cont.style.display = '';
      if (eje >= 0 && data.options && data.options[eje]) { var nombreEje = data.options[eje].name || data.options[eje]; label.textContent = nombreEje; }
      else { label.textContent = 'Opciones'; }
      variantes.forEach(function (v) {
        var etiqueta;
        if (eje >= 0) { etiqueta = v['option' + (eje + 1)] || v.title; } else { etiqueta = v.title; }
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'fp-qa-modal__size';
        b.setAttribute('data-fp-qa-size', v.id);
        b.textContent = etiqueta;
        if (!v.available) b.classList.add('is-oos');
        cont.appendChild(b);
      });
    }

    function seleccionarVariante(vid) {
      if (!estadoModal.data) return;
      var v = (estadoModal.data.variants || []).find(function (x) { return String(x.id) === String(vid); });
      if (!v) return;
      estadoModal.variante = v;
      modalEl.querySelectorAll('[data-fp-qa-size]').forEach(function (el) {
        el.classList.toggle('is-active', String(el.getAttribute('data-fp-qa-size')) === String(vid));
      });
      pintarPrecios(v, estadoModal.data);
      var err = modalEl.querySelector('[data-fp-qa-error]');
      if (err) err.textContent = '';
    }

    function abrirModal(data) {
      crearModal();
      estadoModal.data = data; estadoModal.variante = null;
      modalEl.querySelector('[data-fp-qa-img]').src = data.image || '';
      modalEl.querySelector('[data-fp-qa-img]').alt = data.title || '';
      var edEl = modalEl.querySelector('[data-fp-qa-editorial]');
      edEl.textContent = data.editorial || '';
      edEl.style.display = data.editorial ? '' : 'none';
      modalEl.querySelector('[data-fp-qa-title]').textContent = data.title || '';
      modalEl.querySelector('[data-fp-qa-details]').href = data.url || '#';
      modalEl.querySelector('[data-fp-qa-error]').textContent = '';
      pintarPrecios(null, data);
      pintarTallas(data);
      if ((data.variants || []).length === 1) { seleccionarVariante(data.variants[0].id); }
      modalEl.classList.add('is-open');
      document.documentElement.style.overflow = 'hidden';
    }

    function cerrarModal() {
      if (!modalEl) return;
      modalEl.classList.remove('is-open');
      document.documentElement.style.overflow = '';
    }

    function intentarAgregar() {
      if (!estadoModal.data) return;
      var err = modalEl.querySelector('[data-fp-qa-error]');
      var v = estadoModal.variante;
      if (!v && (estadoModal.data.variants || []).length > 1) { err.textContent = 'Selecciona una talla'; return; }
      if (!v) v = (estadoModal.data.variants || [])[0];
      if (!v || !v.available) { err.textContent = 'Variante no disponible'; return; }
      var boton = modalEl.querySelector('[data-fp-qa-add]');
      boton.disabled = true;
      var textoOriginal = boton.textContent;
      boton.textContent = 'AÑADIENDO...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
      })
        .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw e; }); })
        .then(function () {
          boton.textContent = 'AÑADIDO ✓';
          document.dispatchEvent(new CustomEvent('fp:cart-cambiado'));
          if (window.FPCart && typeof window.FPCart.abrir === 'function') { window.FPCart.abrir(); }
          else { var abrir = document.querySelector('[data-fp-cart-abrir]'); if (abrir) abrir.click(); }
          setTimeout(function () { cerrarModal(); boton.disabled = false; boton.textContent = textoOriginal; }, 500);
        })
        .catch(function (e) {
          boton.disabled = false; boton.textContent = textoOriginal;
          err.textContent = (e && e.description) || 'No se ha podido añadir a la cesta';
        });
    }

    // Florence Paris - exponer el abridor del modal para reutilizarlo desde
    // otras secciones que renderizan tarjetas propias (p.ej. Visto recientemente).
    window.FPQuickAdd = { abrir: abrirModal };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fp-complete-look"] && !Shopify.designMode) return;
  try {
    (function () {
    function iniciar(raiz) {
      if (!raiz || raiz.dataset.fpClListo === 'true') return;
      raiz.dataset.fpClListo = 'true';

      var pista = raiz.querySelector('[data-fp-cl-pista]');
      var prev = raiz.querySelector('[data-fp-cl-prev]');
      var next = raiz.querySelector('[data-fp-cl-next]');
      if (!pista) return;

      var originales = Array.prototype.slice.call(pista.querySelectorAll('[data-fp-cl-tarjeta]'));
      if (!originales.length) {
        raiz.style.display = 'none';
        return;
      }

      for (var i = originales.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = originales[i];
        originales[i] = originales[j];
        originales[j] = tmp;
      }

      /* (26/09) Variedad entre fichas: los productos que la clienta ya vio al principio del carrusel
         en las ultimas fichas pasan al final, y las dos primeras tarjetas nunca son el mismo
         producto en otro color. Memoria solo de la sesion del navegador (sessionStorage). */
      var CLAVE_VISTOS = 'fp_cl_vistos';
      var vistos = [];
      try { vistos = JSON.parse(sessionStorage.getItem(CLAVE_VISTOS) || '[]') || []; } catch (e) { vistos = []; }
      function urlDe(t) { var a = t.querySelector('a[href]'); return a ? a.getAttribute('href').split('?')[0] : ''; }
      function familia(t) { var n = t.querySelector('.fp-cl__nombre'); return n ? n.textContent.split(' - ')[0].trim().toLowerCase() : ''; }
      if (vistos.length && originales.length > 4) {
        var nuevos = originales.filter(function (t) { return vistos.indexOf(urlDe(t)) === -1; });
        var repetidos = originales.filter(function (t) { return vistos.indexOf(urlDe(t)) !== -1; });
        if (nuevos.length >= 2) originales = nuevos.concat(repetidos);
      }
      if (originales.length > 2 && familia(originales[0]) === familia(originales[1])) {
        for (var k = 2; k < originales.length; k++) {
          if (familia(originales[k]) !== familia(originales[0])) {
            var aux = originales[1]; originales[1] = originales[k]; originales[k] = aux; break;
          }
        }
      }
      try {
        vistos = [urlDe(originales[0]), urlDe(originales[1] || originales[0])].concat(vistos)
          .filter(function (u, i, arr) { return u && arr.indexOf(u) === i; }).slice(0, 8);
        sessionStorage.setItem(CLAVE_VISTOS, JSON.stringify(vistos));
      } catch (e) {}

      var infinito = originales.length > 2;

      var fragmento = document.createDocumentFragment();
      originales.forEach(function (t) { fragmento.appendChild(t); });
      if (infinito) {
        originales.forEach(function (t) {
          var copia = t.cloneNode(true);
          copia.setAttribute('data-fp-cl-copia', '');
          copia.setAttribute('aria-hidden', 'true');
          fragmento.appendChild(copia);
        });
      }

      var comportamiento = pista.style.scrollBehavior;
      pista.style.scrollBehavior = 'auto';
      pista.appendChild(fragmento);
      pista.scrollLeft = 0;
      pista.style.scrollBehavior = comportamiento;

      function paso() {
        var t = pista.querySelector('[data-fp-cl-tarjeta]');
        if (!t) return pista.clientWidth;
        var estilo = getComputedStyle(pista);
        var hueco = parseFloat(estilo.columnGap || estilo.gap || '20') || 20;
        return t.getBoundingClientRect().width + hueco;
      }

      function anchoJuego() {
        return paso() * originales.length;
      }

      var ajustando = false;

      function recolocar() {
        if (!infinito || ajustando) return;
        var juego = anchoJuego();
        if (juego <= 0) return;

        if (pista.scrollLeft >= juego) {
          ajustando = true;
          var previo = pista.style.scrollBehavior;
          pista.style.scrollBehavior = 'auto';
          pista.scrollLeft = pista.scrollLeft - juego;
          pista.style.scrollBehavior = previo;
          ajustando = false;
        } else if (pista.scrollLeft <= 0) {
          ajustando = true;
          var previo2 = pista.style.scrollBehavior;
          pista.style.scrollBehavior = 'auto';
          pista.scrollLeft = pista.scrollLeft + juego;
          pista.style.scrollBehavior = previo2;
          ajustando = false;
        }
      }

      function mover(direccion) {
        var juego = anchoJuego();

        if (infinito && juego > 0) {
          if (direccion < 0 && pista.scrollLeft <= 1) {
            var previo = pista.style.scrollBehavior;
            pista.style.scrollBehavior = 'auto';
            pista.scrollLeft = juego;
            pista.style.scrollBehavior = previo;
          }
        }

        pista.scrollBy({ left: direccion * paso(), behavior: 'smooth' });
        setTimeout(recolocar, 520);
      }

      if (prev) prev.addEventListener('click', function () { mover(-1); });
      if (next) next.addEventListener('click', function () { mover(1); });

      function actualizarFlechas() {
        var hayDesbordamiento = pista.scrollWidth > pista.clientWidth + 4;
        if (prev) prev.hidden = !hayDesbordamiento;
        if (next) next.hidden = !hayDesbordamiento;
      }

      var temporizador = null;
      pista.addEventListener('scroll', function () {
        if (temporizador) clearTimeout(temporizador);
        temporizador = setTimeout(recolocar, 140);
      }, { passive: true });

      window.addEventListener('resize', actualizarFlechas);
      actualizarFlechas();
      setTimeout(actualizarFlechas, 600);

      raiz.addEventListener('click', function (evento) {
        var boton = evento.target.closest ? evento.target.closest('[data-fp-cl-anadir]') : null;
        if (!boton || !raiz.contains(boton)) return;

        var tarjeta = boton.closest('[data-fp-cl-tarjeta]');
        var campo = tarjeta ? tarjeta.querySelector('[data-fp-cl-select]') : null;
        if (!campo || !campo.value) return;

        var original = boton.textContent;
        boton.disabled = true;
        boton.textContent = 'A\u00f1adiendo\u2026';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: campo.value, quantity: 1 })
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            boton.textContent = 'A\u00f1adido';
            var abrir = document.querySelector('[data-fp-cart-abrir]');
            if (abrir) abrir.click();
            setTimeout(function () {
              boton.textContent = original;
              boton.disabled = false;
            }, 1500);
          })
          .catch(function () {
            boton.textContent = original;
            boton.disabled = false;
          });
      });
    }

    function iniciarTodo() {
      document.querySelectorAll('[data-fp-cl]').forEach(iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', iniciarTodo);
    } else {
      iniciarTodo();
    }

    document.addEventListener('shopify:section:load', iniciarTodo);
    document.addEventListener('shopify:block:select', iniciarTodo);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fp-favorito"] && !Shopify.designMode) return;
  try {
    (function () {
    function esperarWishlist(intentos) {
      if (window.FPWishlist) {
        iniciar();
        return;
      }
      if (intentos > 40) return;
      setTimeout(function () { esperarWishlist(intentos + 1); }, 50);
    }

    function iniciar() {
      function sincronizarEstado(boton) {
        var handle = boton.dataset.productoHandle;
        if (!handle) return;
        var guardado = window.FPWishlist.isSaved(handle);
        boton.setAttribute('aria-pressed', guardado ? 'true' : 'false');
      }

      function enlazarBotones() {
        document.querySelectorAll('[data-fp-favorito]').forEach(function (boton) {
          if (boton.dataset.fpFavoritoListo) {
            sincronizarEstado(boton);
            return;
          }
          boton.dataset.fpFavoritoListo = 'true';
          sincronizarEstado(boton);
          boton.addEventListener('click', function () {
            var handle = boton.dataset.productoHandle;
            if (!handle) return;
            window.FPWishlist.toggle(handle);
            sincronizarEstado(boton);
          });
        });
      }

      enlazarBotones();
      document.addEventListener('fp:wishlist-cambiada', enlazarBotones);
      var observador = new MutationObserver(enlazarBotones);
      observador.observe(document.body, { childList: true, subtree: true });
    }

    esperarWishlist(0);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fp-price"] && !Shopify.designMode) return;
  try {
    (function () {
    var scriptMapa = document.querySelector('[data-fp-price-mapa]');
    if (!scriptMapa) return;
    var mapa = {};
    try {
      mapa = JSON.parse(scriptMapa.textContent);
    } catch (e) {
      return;
    }

    function actualizarPrecios(idVariante) {
      var datos = mapa[String(idVariante)];
      if (!datos) return;
      document.querySelectorAll('[data-fp-price-instancia]').forEach(function (instancia) {
        var actual = instancia.querySelector('[data-fp-price-actual]');
        var tachado = instancia.querySelector('[data-fp-price-tachado]');
        var descuento = instancia.querySelector('[data-fp-price-descuento]');
        if (actual) actual.textContent = datos.actual;
        if (tachado) {
          tachado.textContent = datos.tachado;
          tachado.hidden = !datos.hayDescuento;
        }
        if (descuento) {
          descuento.textContent = '-' + datos.porcentaje + '%';
          descuento.hidden = !datos.hayDescuento;
        }
      });
      document.dispatchEvent(new CustomEvent('fp:variante-cambiada', { detail: { variantId: idVariante } }));
    }

    function obtenerVarianteActualId() {
      var inputId = document.querySelector('.product-details form[action*="/cart/add"] input[name="id"]');
      return inputId ? inputId.value : null;
    }

    function fpEnlazarCambiosDeVariante() {
      var formulario = document.querySelector('.product-details form[action*="/cart/add"]');
      if (!formulario || formulario.dataset.fpPriceEnlazado) return;
      formulario.dataset.fpPriceEnlazado = 'true';
      formulario.addEventListener('change', function () {
        setTimeout(function () {
          var idActual = obtenerVarianteActualId();
          if (idActual) actualizarPrecios(idActual);
        }, 120);
      });
      formulario.addEventListener('click', function (evento) {
        if (evento.target && evento.target.closest && evento.target.closest('.variant-option__button-label')) {
          setTimeout(function () {
            var idActual = obtenerVarianteActualId();
            if (idActual) actualizarPrecios(idActual);
          }, 150);
        }
      });
    }

    fpEnlazarCambiosDeVariante();
    var observador = new MutationObserver(fpEnlazarCambiosDeVariante);
    observador.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["fp-size-guide"] && !Shopify.designMode) return;
  try {
    (function () {
    function fpInicializarSizeGuide(raiz) {
      var botones = raiz.querySelectorAll('[data-fp-size-guide-abrir]');
      var dialogo = raiz.querySelector('[data-fp-size-guide-dialog]');
      var cerrar = raiz.querySelector('[data-fp-size-guide-cerrar]');
      var pestanaWrap = raiz.querySelector('[data-fp-size-guide-pestana]');
      var descartar = raiz.querySelector('[data-fp-size-guide-descartar]');
      if (!botones.length || !dialogo) return;

      botones.forEach(function (boton) {
        boton.addEventListener('click', function () {
          dialogo.showModal();
        });
      });

      if (cerrar) {
        cerrar.addEventListener('click', function () {
          dialogo.close();
        });
      }

      if (descartar && pestanaWrap) {
        descartar.addEventListener('click', function (evento) {
          evento.stopPropagation();
          pestanaWrap.hidden = true;
          try { sessionStorage.setItem('fp_size_guide_descartada', '1'); } catch (e) {}
        });

        var yaDescartada = false;
        try { yaDescartada = sessionStorage.getItem('fp_size_guide_descartada') === '1'; } catch (e) {}
        if (yaDescartada) pestanaWrap.hidden = true;
      }

      dialogo.addEventListener('click', function (evento) {
        if (evento.target === dialogo) dialogo.close();
      });

      var pestanas = raiz.querySelectorAll('[data-fp-size-guide-tab]');
      pestanas.forEach(function (pestana) {
        pestana.addEventListener('click', function () {
          var destino = pestana.getAttribute('data-fp-size-guide-tab');
          pestanas.forEach(function (p) {
            p.classList.toggle('fp-size-guide__tab--activa', p === pestana);
          });
          raiz.querySelectorAll('[data-fp-size-guide-panel]').forEach(function (panel) {
            panel.classList.toggle('fp-size-guide__panel--oculto', panel.getAttribute('data-fp-size-guide-panel') !== destino);
          });
        });
      });

      /* v13: interruptor CM / IN (IN = cm / 2,54 con un decimal). */
      function fpSgPulgadas(cm) {
        var n = parseFloat(String(cm).replace(',', '.'));
        if (isNaN(n)) return cm;
        var v = Math.round((n / 2.54) * 10) / 10;
        return String(v);
      }
      var botonesUnidad = raiz.querySelectorAll('[data-fp-sg-unidad]');
      botonesUnidad.forEach(function (b) {
        b.addEventListener('click', function () {
          var unidad = b.getAttribute('data-fp-sg-unidad');
          botonesUnidad.forEach(function (o) {
            var activa = o.getAttribute('data-fp-sg-unidad') === unidad;
            o.classList.toggle('fp-sg-unidades__btn--activa', activa);
            o.setAttribute('aria-pressed', activa ? 'true' : 'false');
          });
          raiz.querySelectorAll('[data-cm]').forEach(function (celda) {
            var cm = celda.getAttribute('data-cm');
            celda.textContent = unidad === 'in' ? fpSgPulgadas(cm) : cm;
          });
          raiz.querySelectorAll('[data-fp-sg-u]').forEach(function (u) {
            u.textContent = unidad;
          });
        });
      });

      var botonCalcular = raiz.querySelector('[data-fp-size-guide-calcular]');
      var aviso = raiz.querySelector('[data-fp-size-guide-aviso]');
      var resultado = raiz.querySelector('[data-fp-size-guide-resultado]');

      function analizarTallas(cadena) {
        return cadena.split(';').map(function (fila) {
          var partes = fila.split('|');
          return {
            eu: partes[0],
            busto: parseFloat(partes[1]),
            cintura: parseFloat(partes[2]),
            cadera: parseFloat(partes[3])
          };
        });
      }

      var etiquetasTalla = ['XS', 'S', 'M', 'L', 'XL'];

      if (botonCalcular) {
        botonCalcular.addEventListener('click', function () {
          var busto = parseFloat(raiz.querySelector('[data-fp-size-guide-input="busto"]').value);
          var cintura = parseFloat(raiz.querySelector('[data-fp-size-guide-input="cintura"]').value);
          var cadera = parseFloat(raiz.querySelector('[data-fp-size-guide-input="cadera"]').value);

          if (isNaN(busto) || isNaN(cintura) || isNaN(cadera)) {
            aviso.textContent = 'Introduce las tres medidas para calcular tu talla.';
            resultado.hidden = true;
            return;
          }

          aviso.textContent = '';

          var tallas = analizarTallas(dialogo.getAttribute('data-tallas'));
          var encontrada = null;
          for (var i = 0; i < tallas.length; i++) {
            var t = tallas[i];
            if (busto <= t.busto && cintura <= t.cintura && cadera <= t.cadera) {
              encontrada = t;
              break;
            }
          }

          var esMayor = false;
          if (!encontrada) {
            encontrada = tallas[tallas.length - 1];
            esMayor = true;
          }

          var indice = tallas.indexOf(encontrada);
          var etiqueta = etiquetasTalla[indice] || '';

          resultado.hidden = false;
          resultado.innerHTML = '<strong>Talla recomendada: ' + etiqueta + ' (EU ' + encontrada.eu + ')</strong>' +
            (esMayor ? 'Tus medidas superan nuestra tabla estándar; te recomendamos la talla más grande disponible.' : 'Según las medidas introducidas.');
        });
      }
    }

    document.querySelectorAll('.fp-size-guide').forEach(fpInicializarSizeGuide);
  })();
  } catch(e) { console.error(e); }
})();

})();
